import { icon } from "@fortawesome/fontawesome-svg-core";

export default [
  {
    title: "Tablero",
    icon: "fa-house",
    fontAwesome: true,
    tagVariant: "light-warning",
    route: "home",
    resource: "Home",
    action: "read",
  },

  {
    title: "Usuarios",
    icon: "fa-users",
    fontAwesome: true,
    children: [
      {
        title: "Autores",
        route: "listar.autores",
        action: "read",
        resource: "Autores",
        icon: "fa-user-pen",
        fontAwesome: true,
      },

      {
        title: "Autores por encargos",
        route: "listar.autores_por_encargo",
        action: "read",
        resource: "Autores por encargos",
        icon: "fa-user-pen",
        fontAwesome: true,
      },

      {
        title: "Partners",
        route: "listar.promotores",
        action: "read",
        resource: "Promotores",
        icon: "fa-user-tie",
        fontAwesome: true,
      },
      {
        title: "Administradores",
        route: "listar.administradores",
        action: "read",
        resource: "Administradores",
        icon: "fa-user-shield",
        fontAwesome: true,
      },
    ],
  },

  {
    title: "Biografías",
    route: "biografia.list",
    action: "read",
    resource: "Biografías",
    icon: "fa-book-open",
    fontAwesome: true,
  },

  {
    title: "Precios & Cupones",
    icon: "fa-money-check",
    fontAwesome: true,
    children: [
      {
        title: "Lotes de Páginas",
        route: "lote.list",
        action: "read",
        resource: "Lotes",
        icon: "fa-table-list",
        fontAwesome: true,
      },

      {
        title: "Planes",
        route: "plan.list",
        action: "read",
        resource: "Planes",
        icon: "fa-table-list",
        fontAwesome: true,
      },

      {
        title: "Cupones",
        route: "cupon.list",
        action: "read",
        resource: "Cupones",
        icon: "fa-ticket",
        fontAwesome: true,
      },
    ],
  },

  {
    title: "Productos & Categorías",
    icon: "fa-boxes-stacked",
    fontAwesome: true,
    children: [
      // pendiente
      {
        title: "Productos",
        route: "listar.productos",
        action: "read",
        resource: "Productos",
        icon: "fa-box-open",
        fontAwesome: true,
      },
      {
        title: "Categorías",
        route: "listar.categorias",
        action: "read",
        resource: "Categorías de productos",
        icon: "fa-list",
        fontAwesome: true,
      },
    ],
  },

  {
    title: "Materiales Promocionales",
    icon: "fa-bullhorn",
    fontAwesome: true,
    route: "materiales.promocionales",
    action: "read",
    resource: "Materiales promocionales",
  },
  {
    title: "Retiros",
    icon: "fa-money-bill-transfer",
    route: "retiros.list",
    fontAwesome: true,
    action: "read",
    resource: "Retiros",
  },

  {
    title: "Salón de los Inmortales",
    route: "salon.inmortales",
    action: "read",
    resource: "Salón de los Inmortales",
    icon: "fa-trophy",
    fontAwesome: true,
  },

  {
    title: "Solicitudes",
    icon: "fa-user-plus",
    fontAwesome: true,
    route: "solicitud.list",
    action: "read",
    resource: "Solicitudes",
  },

  {
    title: "Reportes",
    icon: "fa-rectangle-list",
    fontAwesome: true,
    children: [
      {
        title: "Estado de Cuenta",
        icon: "fa-money-bill-transfer",
        route: "estado.cuentas",
        fontAwesome: true,
        action: "read",
        resource: "Estado de cuentas",
      },
    ],
  },

  // Configuraciones
  {
    title: "Configuraciones",
    icon: "fa-cogs",
    fontAwesome: true,
    children: [
      {
        title: "Conf Sistema",
        icon: "fa-gear",
        fontAwesome: true,
        resource: "Sistema",
        action: "read",
        children: [
          // Configuracion general
          {
            title: "General",
            route: "sistema",
            action: "read",
            resource: "Sistema",
            icon: "fa-gear",
            fontAwesome: true,
          },

          // Paypal

          {
            title: "Paypal",
            route: "paypal",
            action: "read",
            resource: "Paypal",
            icon: "fa-cog",
            fontAwesome: true,
          },

          // Roles y permisos
          {
            title: "Roles",
            route: "listar.roles",
            action: "read",
            resource: "Roles",
          },
          {
            title: "Permisos",
            route: "listar.permisos",
            action: "read",
            resource: "Permisos",
          },
        ],
      },

      {
        title: "Conf Biografías",
        icon: "fa-book",
        fontAwesome: true,
        action: "read",
        resource: "Tipos de biografías",
        children: [
          {
            title: "Tipos de Biografías",
            route: "listar.tipo_biografias",
            action: "read",
            resource: "Tipos de biografías",
          },

          {
            title: "Biografías Beneficiables",
            route: "listar.biografias_beneficiables",
            action: "read",
            resource: "Biografias beneficiables",
            icon: "fa-book-bookmark",
            fontAwesome: true,
          },

          {
            title: "Tamaños de Hojas (Papel)",
            route: "papel.list",
            action: "read",
            resource: "Configuraciones",
          },

          {
            title: "Cuestionarios",
            route: "cuestionario.list",
            action: "read",
            resource: "Cuestionarios",
          },
          {
            title: "Preguntas",
            route: "preguntas.list",
            action: "read",
            resource: "Preguntas",
          },
        ],
      },

      {
        title: "Conf de ventas",
        icon: "fa-cart-shopping",
        fontAwesome: true,
        action: "read",
        resource: "Objetivos",
        children: [
          {
            title: "Descuentos",
            route: "descuento.list",
            action: "read",
            resource: "Descuentos",
          },
          {
            title: "Objetivos",
            route: "objetivos.list",
            action: "read",
            resource: "Objetivos",
            icon: "fa-bullseye",
            fontAwesome: true,
          },
        ],
      },

      {
        title: "Soporte",
        icon: "fa-circle-question",
        fontAwesome: true,
        action: "read",
        resource: "Preguntas frecuentes",
        children: [
          {
            title: "Videos de Ayuda",
            route: "admin.videos.list",
            action: "write",
            resource: "Vídeos de Ayuda",
          },

          {
            title: "Preguntas Frecuentes",
            route: "faq.list",
            action: "read",
            resource: "Preguntas frecuentes",
            icon: "fa-comments",
            fontAwesome: true,
            exact: true,
          },
        ],
      },
    ],
  },
];
